import CheckboxCard from '@monofront/design-system/components/CheckboxCard';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { ICollection } from '@monofront/types';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { RichText } from 'prismic-reactjs';
import { toggle } from 'radash';
import {
  ChoicesContainer,
  MultipleChoicesLayout,
  TextContainer,
} from '@monofront/design-system/components/MultipleChoicesLayout';

import type { JSX } from "react";

/**
 * Props for `MultiSelectCollection`.
 */
export type MultiSelectCollectionProps =
  SliceComponentProps<Content.MultiSelectCollectionSlice>;

/**
 * Component for "MultiSelectCollection" Slices.
 */
const MultiSelectCollection = ({
  slice,
  onChange,
  formValue = [],
}: MultiSelectCollectionProps & {
  onChange: (value: any) => void;
  formValue: Array<string>;
}): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <MultipleChoicesLayout>
        <TextContainer>
          <RichText render={slice.primary.title} />
          <RichText render={slice.primary.subtitle} />
        </TextContainer>
        <ChoicesContainer>
          {slice.items.map((item, index) => {
            if (!item.collection) {
              return null;
            }

            return (
              <CheckboxCard
                dataTestId="multi-select-collection-checkbox"
                key={index}
                checkboxName={(item.collection as ICollection).handle}
                label={item.title}
                checked={formValue.includes(
                  (item.collection as ICollection).handle,
                )}
                value={(item.collection as ICollection).handle}
                handleChecked={(value) => {
                  const newValues = toggle(formValue, value);

                  onChange(newValues);
                }}
              >
                {item.image.url && (
                  <ResponsiveImage
                    src={item.image.url}
                    alt={item.image.alt || ''}
                    width={32}
                    height={32}
                  />
                )}
              </CheckboxCard>
            );
          })}
        </ChoicesContainer>
      </MultipleChoicesLayout>
    </section>
  );
};

export default MultiSelectCollection;
